import { render, staticRenderFns } from "./visitSeparation.vue?vue&type=template&id=84daf0c2"
import script from "./visitSeparation.vue?vue&type=script&lang=js"
export * from "./visitSeparation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports